import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { CandidaciesQuery as CandidaciesQueryType, CandidaciesQueryVariables } from "./__generated__/CandidaciesQuery";

const CandidaciesQuery = loader("./CandidaciesQuery.gql");

type CandidaciesQueryProviderType = (props: {
  children: (data: CandidaciesQueryType) => ReactNode;
  variables: CandidaciesQueryVariables;
}) => ReactElement;

export const CandidaciesQueryProvider: CandidaciesQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<CandidaciesQueryType, CandidaciesQueryVariables>(CandidaciesQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
